import React from 'react';
import dayjs from 'dayjs';
import { Box, Flex, Text } from '@chakra-ui/react';
import Avatar from './AuthorAvatar';
import type { Post } from '../../libs/sanity.queries';
import CoverImage from './CoverImage';

export default function PostHeader(props: Pick<Post, 'title' | 'coverImage' | 'date' | 'author' | 'slug'>) {
  const { title, coverImage, date, author, slug } = props;
  return (
    <>
      <Box mb={{ base: 8, md: 12 }}>
        <CoverImage title={title} image={coverImage} slug={slug} />
      </Box>
      <Flex justify='space-between' mb={10}>
        {author && <Avatar name={author.name} jobTitle={author.jobTitle} image={author.image} />}
        {date && <Text color='bg-default-inverted'>{dayjs(date).format('D MMMM, YYYY')}</Text>}
      </Flex>
    </>
  );
}
